import { defineComponent as _defineComponent } from 'vue'
import { useInstance } from '@/composables/useInstance';
import { useImageOptimize } from '@/composables/useImageOptimize';
import { AutomationTestsIds } from '@/env/AutomationTests/ids/AutomationTestsIds';
type UserButtonProps = {
  name: string,
  icon: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserButton',
  props: {
    name: null,
    icon: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { name: string, icon: boolean };



const { $user, } = useInstance();
const { optimizeAvatar } = useImageOptimize();


return { __sfc: true,props, $user, optimizeAvatar, AutomationTestsIds }
}

})